import { createSelector } from "reselect";
import { adminSectionSelector } from "../admin_section_selector";

export const checkedOrganizationIdsSelector = createSelector(
  adminSectionSelector,
  organizationSection => {
    return organizationSection.checkedOrganizationIds;
  }
);
